import { SyntheticEvent, useState } from 'react';
import { CloseReason, SpeedDial, SpeedDialAction, Stack } from '@mui/material';
import { Autorenew, CallMissed, ListAlt, ThumbsUpDown, RequestQuote, TrendingUp } from "@mui/icons-material";
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import Loading from "../../../components/atoms/Loading";
import UnderwritingTemplate from '../../../components/templates/UnderwritingTemplate';
import { DropResult } from 'react-beautiful-dnd';
import { useModels } from '../hooks/useModels';
import ModelsTable from '../components/organisms/ModelsTable';
import { underwritingOptions } from '../../../constants/underwritingOptions';
import { Models } from '../api/api-types';
import { useDeleteApiV1UnderwritingModelsByModelIdMutation, usePostApiV1UnderwritingModelsByModelIdMutation, usePostApiV1UnderwritingModelsMutation } from '../api';
import AddOrCreateModel from './AddOrCreateModel';
import { ModelTypes } from '../types/model';

const ModelMain = () => {

    const [open, setOpen] = useState(false);
    const [editModel, setEditModel] = useState<number | null>();
    const [editModelType, setEditModelType] = useState<ModelTypes | "EXISTING" | null>(null);
    const [updateModel] = usePostApiV1UnderwritingModelsByModelIdMutation();
    const [postModel] = usePostApiV1UnderwritingModelsMutation();
    const [deleteModel] = useDeleteApiV1UnderwritingModelsByModelIdMutation();

    const { models, isFetching } = useModels();
    const otherModels = models?.filter(m => m.modelType !== "Risk")
    const riskModels = models?.filter(m => m.modelType === "Risk")

    const closeSpeedDial = (e: SyntheticEvent<{}, Event>, reason: CloseReason) => {
        if (reason === "mouseLeave" && open) {
            const closeDelay = setTimeout(() => {
                setOpen(false)
            }, 2000)
            return () => clearTimeout(closeDelay)
        }
        else { setOpen(false) }
    }

    function openType(type: ModelTypes) {
        setOpen(true);
        setEditModelType(type);
        setEditModel(999);
    }

    function closeModal() {
        setEditModelType(null)
        setEditModel(null);
    }

    function handleEditModel(modelID: number) {
        setEditModel(modelID);
        setEditModelType("EXISTING")
    }

    const handleDragEndOtherModels = async (result: DropResult) => {
        console.error(`This feature has been deprecated.`)
    }

    async function handleSubmit(d: Models): Promise<void> {
        if (d.modelId === 0) {
            await postModel({ ...d }).unwrap()
        } else {
            await updateModel({
                modelId: d.modelId,
                underwriteModelUpdate: { ...d, }
            }).unwrap()
        }
        closeModal();
    }

    async function handleDelete(modelID: number) {
        try {
            await deleteModel(modelID).unwrap();
        } catch (err) {

        } finally {
            closeModal();
        }
    }

    return (
        <UnderwritingTemplate
            tableArea = {
                <Stack spacing={1}>
                    {/*Loading indicator*/}
                    {isFetching && (<Loading />)}

                    {/*Main models table*/}
                    {otherModels.length > 0 && (<ModelsTable droppableId="models" title="Models Table" data={otherModels} onRowClick={handleEditModel} onDragEnd={handleDragEndOtherModels} options={underwritingOptions} />)}

                    {/*Risk models table*/}
                    {riskModels.length > 0 && (<ModelsTable title="Risk Models Table" data={riskModels} onRowClick={handleEditModel} options={underwritingOptions} />)}
                </Stack>
            }
            modalActions = {
                <>
                    {editModelType && editModel && <AddOrCreateModel title={editModelType === "EXISTING" ? `Edit Model ID ${editModel}` : 'Create Model'} open={editModelType !== null} onClose={closeModal} >
                        {editModelType !== "EXISTING" ? <AddOrCreateModel.Create onSubmit={handleSubmit} type={editModelType} /> : <AddOrCreateModel.Edit onDelete={handleDelete} onSubmit={handleSubmit} modelID={editModel} />}
                    </AddOrCreateModel>}

                    <SpeedDial ariaLabel={'New Model'} open={open} FabProps={{ color: "secondary" }}
                        direction={'left'}
                        onOpen={() => setOpen(true)}
                        onClose={closeSpeedDial}
                        icon={<SpeedDialIcon />}>
                        <SpeedDialAction icon={<ThumbsUpDown />} title={'Decision'} tooltipTitle={'Decision'}
                            tooltipPlacement={'top'}
                            onClick={() => openType('Decision')} />
                        <SpeedDialAction icon={<ListAlt />} title={'Deny'} tooltipTitle={'Deny'}
                            tooltipPlacement={'top'}
                            onClick={() => openType('Deny')} />
                        <SpeedDialAction icon={<Autorenew />} title={'Price'} tooltipTitle={'Price'}
                            tooltipPlacement={'top'}
                            onClick={() => openType('Price')} />
                        <SpeedDialAction icon={<CallMissed />} title={'Risk'} tooltipTitle={'Risk'}
                            tooltipPlacement={'top'}
                            onClick={() => openType('Risk')} />
                        <SpeedDialAction icon={<RequestQuote />} title={'BidWinRate'} tooltipTitle={'BidWinRate'}
                             tooltipPlacement={'top'}
                             onClick={() => openType('BidWinRate')} />
                         <SpeedDialAction icon={<TrendingUp />} title={'Conversion'} tooltipTitle={'Conversion'}
                            tooltipPlacement={'top'}
                            onClick={() => openType('Conversion')} />
                    </SpeedDial>
                </>}
        />
    )
}

export default ModelMain;